module.exports = __webpack_public_path__ + "img/frame (97).35be8bb0.jpg";